import { combineReducers } from 'redux';
import { fetchReports, fetchLeftCostReports, fetchRightCostReports } from '../../sagas/dashboard/actions';
import { logoutButtonClick } from '../../components/Auth/actions';

const distanceReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[0];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const durationReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[1];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const fuelCostReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[2];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const fuelConsumptionReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[3];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const speedingReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[4];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const corneringReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[5];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const brakingReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[6];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const acceleratingReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[7];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const journeyScoreReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[8];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const leftCostReport = (state = {}, action) => {
  if (action.type === fetchLeftCostReports.done.type) {
    return action.payload.result.reports[0];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const rightCostReport = (state = {}, action) => {
  if (action.type === fetchRightCostReports.done.type) {
    return action.payload.result.reports[0];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

export default combineReducers({
  distanceReport,
  durationReport,
  fuelConsumptionReport,
  fuelCostReport,
  speedingReport,
  corneringReport,
  brakingReport,
  acceleratingReport,
  leftCostReport,
  rightCostReport,
  journeyScoreReport,
});



// WEBPACK FOOTER //
// ./src/reducers/dashboard/reports.js